var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1616_37525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.65 41.4097H1.37444C0.898363 41.4097 0.512329 41.0236 0.512329 40.5476V9.51321C0.512329 9.03714 0.898363 8.65111 1.37444 8.65111H49.6501C50.1262 8.65111 50.5122 9.03714 50.5122 9.51321V40.5476C50.5121 41.0236 50.1261 41.4097 49.65 41.4097Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5121 9.51321C50.5121 9.03714 50.1261 8.65111 49.65 8.65111H45.7931L29.8225 19.1146V8.65111H21.2018V19.1146L5.23126 8.65111H1.37444C0.898363 8.65111 0.512329 9.03714 0.512329 9.51321V11.7428L14.2143 20.72H0.512329V29.3407H14.2143L0.512329 38.318V40.5476C0.512329 41.0236 0.898363 41.4097 1.37444 41.4097H5.23135L21.202 30.9461V41.4097H29.8227V30.9461L45.7933 41.4097H49.6502C50.1263 41.4097 50.5123 41.0236 50.5123 40.5476V38.318L36.8103 29.3408H50.5121V20.7201H36.8101L50.5121 11.7428V9.51321Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5121 22.4442H28.0984V8.65111H22.926V22.4442H0.512329V27.6166H22.926V41.4097H28.0984V27.6166H50.5121V22.4442Z",
    fill: "#FF4B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.988 29.3408L0.537048 40.6686C0.598083 41.0849 0.941344 41.4098 1.37464 41.4098H2.56204L21.1547 29.3409H17.988V29.3408Z",
    fill: "#FF4B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3398 29.3408H31.173L49.7386 41.3919C50.1713 41.3458 50.5128 40.9925 50.5128 40.5476V39.8388L34.3398 29.3408Z",
    fill: "#FF4B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.512939 10.4649L16.3116 20.7202H19.4784L1.01518 8.73526C0.720263 8.87227 0.512939 9.1667 0.512939 9.51328V10.4649Z",
    fill: "#FF4B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9902 20.7202L50.483 9.36509C50.4103 8.96255 50.0744 8.65132 49.6508 8.65132H48.4158L29.8234 20.7202H32.9902Z",
    fill: "#FF4B55"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1616_37525"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.511719 0.0305176)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.d512429fcbff04d490e49c9b09b93c2f.svg";
export { ForwardRef as ReactComponent };